<template>
  <div>
    <b-card v-for="item in reply" :key="item.id" :sub-title="item.label">
      <b-card-text>
        {{ parseResponse(item) }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { fieldTypes } from '@/utils/fieldTypeCodes'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    }
  },

  created () {
    this.parseReply()
  },

  data () {
    return {
      reply: []
    }
  },

  methods: {
    parseReply () {
      this.reply = JSON.parse(this.entity.reply).sort((r1, r2) => {
        if (r1.position > r2.position) return 1
        else if (r1.position < r2.position) return -1
        else return 0
      })
    },

    parseResponse (item) {
      let ret = null

      switch (item.type) {
        case fieldTypes.NUMERIC:
          ret = `${item.response} / 5`
          break
        case fieldTypes.TEXT:
        case fieldTypes.DROP_DOWN_MENU:
          ret = item.response
          break
        case fieldTypes.BOOLEAN:
          ret = item.response
          break
        case fieldTypes.PARAGRAPH:
          ret = null
          break
      }

      return ret
    }
  }
}
</script>
